<template>
  <div class="container is-fluid">
    <button class="button">{{ athletes.length }} athletes</button>
    
    <div class="field is-pulled-right" v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('director') || $auth.user.roles.includes('admin'))">
       <div class="select ">
            
            <select  v-model="roundId"  >
                <option value="0">Select Funding Round ...</option>
                <option v-for="row in rounds" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
       
        <div class="select ">
            
            <select  v-model="governingBodyId"  >
                <option value="0">Select Governing Body ...</option>
                <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
         <div class="select ">
            
            <select  v-model="councilAreaId"  >
                <option value="0">Select Council Area ...</option>
                <option v-for="row in council_areas" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
    </div>

    
    
    <table class="table is-hoverable is-fullwidth" id="AthleteContactDetails">
    	<thead>
    		<th>Name</th>
            <th>Athlete Email</th>
          <th>Parent Email</th>
            <th>Date</th>
        <th>Governing Body</th>
          <th >Amount</th>
          <th >Round</th>
          
          
    	</thead>

        <tbody>
            <tr v-for="row in athletes" :key="row.id">
                <td>{{ row.forename }} {{ row.surname }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.parent_email }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.governing_body_name }}</td>
                <td>{{ row.amount }}</td>
                <td>{{ row.round_name }}</td>
                
            </tr>

        </tbody>
    	
		    
    
    </table>
    
    <div class="buttons">
    <button class="button is-link" @click="exportPDF()">Export Results to PDF</button>
    <button class="button is-success" @click="exportXLS()">Export Results to Excel</button>
    </div>
    

  </div>
</template>

<script>


import ApplicationService from '@/services/ApplicationService.js';
import { jsPDF } from "jspdf";
import 'jspdf-autotable'
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  data() {
    return {
      orders: [],
      errors: [],
      athletes: [],
      governing_bodies:[],
      council_areas:[],
      rounds: [],
      orderBy:"",
      governingBodyId: 0,
      councilAreaId: 0,
      roundId:process.env.VUE_APP_CURRENT_ROUND_ID,
    }
  },
  
  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
        this.getAthletes();
      this.getGoverningBodies();
      this.getCouncilAreas();
       this.getRounds();
    });
  },
  watch: {
    '$route'() {
     this.getAthletes();
    
    },
    governingBodyId: function() {
      this.getAthletes();
      
    },
    councilAreaId: function() {
      this.getAthletes();
     
    },
    roundId: function() {
      this.getAthletes();
     
    }
  },
  methods: {
  	async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
    async getGoverningBodies() {
        
      ApplicationService.getGoverningBodies("")
      .then(
        (governing_bodies => {
          this.$set(this, "governing_bodies", governing_bodies);
        }).bind(this)
      );
    },
    async getCouncilAreas() {
       
      ApplicationService.getCouncilAreas("")
      .then(
        (council_areas => {
          this.$set(this, "council_areas", council_areas);
        }).bind(this)
      );
    },
    async getRounds() {
       
      ApplicationService.getRounds(this.accessToken)
      .then(
        (rounds => {
          this.$set(this, "rounds", rounds);
        }).bind(this)
      );
    },
    async getAthletes() {
     
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getFundedAthletes(this.accessToken, '', this.governingBodyId, this.councilAreaId, this.orderBy, this.roundId)
      .then(
        (athletes => {
          this.$set(this, "athletes", athletes);
        }).bind(this)
      );
    },
    exportPDF()
    {
      var doc = new jsPDF('portrait', 'mm', 'a4');
      doc.setFontSize(20);
      
      doc.autoTable({ html: '#athleteReport', useCss: true   })

      doc.save('AthleteContactDetails.pdf');
    },
     exportXLS() {
        //alert("hi")
        var wb = XLSX.utils.table_to_book(document.getElementById('AthleteContactDetails'), {sheet:"Sheet JS"});
        XLSX.writeFile(wb, 'athlete-contact-details.xlsx')

    },
    
    
  }
}


</script>

<style>
	
</style>
